import React, { useState, useEffect } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";

const EditBranchProductCategory = () => {
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    description: ""
  });
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const axios = AxiosApiCall();

  // Load existing data into form
  useEffect(() => {
    if (location.state?.data) {
      const data = location.state.data;
      setFormData({
        id: data.id,
        name: data.name || "",
        description: data.description || ""
      });
    }
  }, [location.state]);

  const validateForm = () => {
    if (!formData.name || !formData.description) {
      toast.error("All fields are required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.post(
        ApiServices.updateBranchProductCategory,
        {
          id: formData.id,
          name: formData.name,
          description: formData.description
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
          withCredentials: true
        }
      );

      const { status, message } = response.data;
      if (status === "200") {
        toast.success(message || "Updated successfully.");
        navigate("/operations/branch/products/category");
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (err) {
      handleError(err, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayouts>
      <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
        <section className="body-font">
          <div className="container px-5 pb-2 mx-auto">
            <section
              className="w-full pr-[3%] pt-3 my-3"
              style={{ backgroundColor: "#F7F7F7" }}
            >
              <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                <ol className="list-none p-0 inline-flex mb-2">
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                      Operations
                    </p>
                    <ChevronRightIcon />
                  </li>
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                      Branch
                    </p>
                    <ChevronRightIcon />
                  </li>
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                      Product Category
                    </p>
                    <ChevronRightIcon />
                  </li>
                  {/* <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                      Category
                    </p>
                    <ChevronRightIcon />
                  </li> */}
                  <li className="flex items-center">
                    <p className="text-orange1">Update</p>
                  </li>
                </ol>
              </nav>
            </section>

            <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
              <form onSubmit={handleSubmit}>
                <input type="hidden" value={formData.id} />
                <div className="d-flex">
                  <div className="w-full mb-3">
                    <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">
                      Name
                    </label>
                    <input
                      type="text"
                      name="name"
                      id="name"
                      value={formData.name}
                      onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      placeholder="Enter name"
                    />
                  </div>

                  <div className="w-full mb-3">
                    <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">
                      Description
                    </label>
                    <textarea
                      rows="4"
                      name="description"
                      id="description"
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                      className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                      placeholder="Enter description"
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                  <Link
                    to="/operations/branch/products/category"
                    className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 font-medium rounded-lg text-sm px-5 text-center flex items-center"
                  >
                    <List className="mr-2" />
                    Back To List
                  </Link>
                  <button
                    type="submit"
                    className={`text-white text-dGrey3  bg-darkGreen3 border-0 py-2 px-6 rounded font-medium ${loading ? "btn-loading" : "btn-primary"
                      }`}
                    disabled={loading}
                  >
                    {loading ? "Updating..." : "Update  Product Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </MainLayouts>
  );
};

export default EditBranchProductCategory;
